//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useCallback } from 'react';
import ConfirmEmailService from '../Services/ConfirmEmailService';
//  ----------      END   IMPORT  BLOCK       ----------

export const useConfirmEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const confirm = useCallback(async (token) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const service = new ConfirmEmailService();
      const response = await service.confirmEmail(token);
      
      setIsSuccess(true);
      return response;
    } catch (err) {
      // Capture the error message from your API response
      const errorMessage = err.response?.data?.detail || "Verification failed";
      setError(errorMessage);
      throw err; // Re-throw so the component can handle specific logic if needed
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { confirm, isLoading, error, isSuccess };
};